module.exports = __webpack_public_path__ + "fonts/IBMPlexMono-Regular.0c3db5c1.woff";